import { useAppSelector } from "@hypexone/uicore";
import React, { useState } from "react";
import Button from "./Button/Button";

interface PaginatorProp {
  setFilters: any;
  filters: any;
  pageToken: any;
  // currentPage:any;
}
const Paginator: React.FC<PaginatorProp> = ({
  // currentPage,
  // totalPages,
  // onPageChange,
  filters,
  setFilters,
  pageToken,
}) => {
  const [nextPageToken, setNextPageToken] = useState<string>(null);
  const { langData } = useAppSelector((state) => state.cms);

  // const handlePrevious = () => {
  //   if (currentPage > 1) {
  //     onPageChange(currentPage - 1);
  //   }
  // };

  // const handleNext = () => {
  //   if (currentPage < totalPages) {
  //     onPageChange(currentPage + 1);
  //   }
  // };
  const nextPage = () => {
    setFilters({
      ...filters,
      pageToken: [...filters.pageToken, pageToken],
    });
  };

  const prevPage = () => {
    if (filters.pageToken.length > 0) {
      let pagetokens = filters.pageToken;
      pagetokens.pop();
      setFilters({ ...filters, pageToken: [...pagetokens] });
    }
    setNextPageToken(null);
  };

  return (
    <div className="flex items-center justify-center space-x-4 border rounded-lg p-2">
      <Button
        onClick={(e) => prevPage()}
        className="px-3 py-1 text-gray-500 hover:text-gray-700 focus:outline-none"
        disabled={filters?.pageToken.length <= 0}
      >
        « {langData?.["previous"]}
      </Button>
      <div className="px-4 py-2 bg-black text-white rounded-lg">
        {/* {currentPage} */}
        {filters.pageToken.length + 1}
      </div>
      <Button
        onClick={(e) => nextPage()}
        className="px-3 py-1 text-gray-500 hover:text-gray-700 focus:outline-none"
        disabled={pageToken == null || pageToken == ""}
      >
        {langData?.["next"]} »
      </Button>
    </div>
  );
};

export default Paginator;
